<template>
    <div>
        <a-drawer
            id="cus_drawer_1"
            title="批量操作客户标签"
            placement="right"
            width="80%"
            :maskClosable="true"
            :closable="true"
            :visible="visible"
            :after-visible-change="afterVisibleChange"
            @close="close"
        >
            <div class="customer_list">
                <div class="customer_in" :class="[visibleChild ? 'customer_in_active' : '']">
                    <a-table
                        :columns="columns"
                        :data-source="dataList"
                        :pagination="false"
                        :row-key="(record) => record.id"
                    >
                        <template slot="name" slot-scope="text, record">
                            <a-space size="small" class="dir_left_wrap">
                                <span>{{ record.name }}</span>
                                <a-icon
                                    v-if="record.gender"
                                    slot="count"
                                    :type="record.gender === 1 ? 'man' : 'woman'"
                                    :style="record.gender === 1 ? 'color:blue;' : 'color:pink;'"
                                />
                                <span :style="record.type === 1 ? 'color:#87d068;' : 'color:gold;'">
                                    {{ record.type === 1 ? '@微信' : `@${record.corpName}` }}
                                </span>
                            </a-space>
                        </template>
                        <!-- <template slot="user" slot-scope="text, record">
                            <openData type="userName" :openid="record.userId"></openData>
                        </template> -->
                        <template slot="tag" slot-scope="text, record">
                            <a-space class="dir_left_wrap cross_center">
                                <a-tag v-for="item in record.tag" :key="item.tagId" style="margin-bottom: 5px;">
                                    {{ item.tagName }}
                                </a-tag>
                            </a-space>
                        </template>
                        <template slot="action" slot-scope="record">
                            <a-button type="link" @click="deleteCustomer(record)" style="margin-left: -12px;">
                                移除
                            </a-button>
                        </template>
                    </a-table>
                </div>
            </div>
            <a-affix :offset-bottom="0">
                <div style="background-color: #fff; padding: 10px 0;" class="step_1" :class="[visibleChild ? 'customer_in_active' : '']">
                    <a-button type="primary" @click="openChild">
                        设置标签
                    </a-button>
                </div>
            </a-affix>
        </a-drawer>
        <a-drawer
            id="cus_drawer_2"
            title="客户标签"
            placement="right"
            width="500"
            :maskClosable="false"
            :closable="true"
            :visible="visibleChild"
            :maskStyle="{backgroundColor: 'rgba(0,0,0,0.2)'}"
            @close="closeChild"
        >
            <div class="tag_list">
                <div class="tag_in">
                    <a-space direction="vertical" size="large">
                        <li v-for="item in dataTagList" :key="item.groupId">
                            <p>{{ item.groupName }}</p>
                            <a-space class="dir_left_wrap">
                                <a-checkable-tag
                                    v-for="el in item.tag"
                                    :key="el.tagId"
                                    :checked="selectKeys.map((col) => col.tagId).includes(el.tagId)"
                                    @change="(checked) => tagChange(el, checked)"
                                    style="margin-bottom: 5px;"
                                >
                                    {{ el.tagName }}
                                </a-checkable-tag>
                            </a-space>
                        </li>
                    </a-space>
                    <div style="margin-top: 10px;position: fixed; right: 40px; top: 60px;" v-if="visibleChild">
                        <a-button icon="plus" @click="openTag">
                            新增标签
                        </a-button>
                    </div>
                </div>
            </div>
            <a-affix :offset-bottom="0">
                <div style="background-color: #fff; padding: 10px 0;">
                    <a-button type="primary" @click="tagUpData(1)">
                        标签批量新增
                    </a-button>
                    <a-divider type="vertical" />
                    <a-button @click="tagUpData(2)">
                        标签批量删除
                    </a-button>
                </div>
            </a-affix>
        </a-drawer>
        <a-drawer
            id="cus_drawer_3"
            title="标签列表"
            placement="top"
            height="100%"
            :maskClosable="false"
            :closable="true"
            :visible="visibleTag"
            @close="closeTag"
        >
            <tagList :show="visibleTag"></tagList>
        </a-drawer>
    </div>
</template>

<script>
import _ from 'lodash';
import api from '@/apis';
import openData from '@/components/group/openData';
import tagList from '@/components/group/tagList';
export default {
    // 批量操作客户标签
    name: 'batch_customer_tag',
    components: {
        openData,
        tagList
    },
    props: {
        data: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            visible: false,
            visibleChild: false,
            visibleTag: false,
            dataList: [],
            columns: [
                {
                    title: '客户',
                    key: 'name',
                    scopedSlots: { customRender: 'name' },
                    width: '30%'
                },
                // {
                //     title: '添加成员',
                //     key: 'userId',
                //     scopedSlots: { customRender: 'user' }
                // },
                {
                    title: '标签',
                    key: 'tag',
                    scopedSlots: { customRender: 'tag' }
                },
                {
                    title: '操作',
                    width: 100,
                    scopedSlots: { customRender: 'action' }
                }
            ],
            // 客户id
            contactId: [],
            // 接口请求所有标签
            dataTagList: [],
            // 选中标签
            selectKeys: [],
        };
    },
    watch: {},
    methods: {
        open() {
            this.visible = true;
            this.dataList = this.data;
            if (this.data && this.data.length > 0) {
                // 收集客户ID
                this.contactId = _.map(this.data, 'id');
            }
        },
        close() {
            this.visible = false;
            this.selectKeys = [];
            this.$emit('backStatus', true);
        },
        afterVisibleChange(val) {
            // console.log('visible', val);
        },
        openChild() {
            if (this.data && this.data.length === 0) return this.$message.error('未获取客户信息');
            this.visibleChild = true;
            this.getTag();
        },
        closeChild() {
            this.visibleChild = false;
        },
        // 删除客户
        deleteCustomer(record) {
            if (!record || !record.id || !this.data || this.data.length === 0) return this.$message.error('未获取客户信息');
            const that = this;
            try {
                this.$confirm({
                    title: `确认移除客户？`,
                    icon: 'info-circle',
                    async onOk() {
                        that.dataList = that.dataList.filter(item => item.id !== record.id);
                        // 收集客户ID
                        that.contactId = _.map(that.dataList, 'id');
                    },
                    onCancel() {}
                });
            } catch (err) {
                console.log(err);
            }
        },
        // 获取标签
        async getTag() {
            try {
                const res = await api.getTag();
                if (res.code !== 0) return;
                this.dataTagList = res.tagGroup;
            } catch (err) {
                console.log(err);
            }
        },
        tagChange(el, checked) {
            if (checked) {
                this.selectKeys.push(el);
            } else {
                this.selectKeys = _.differenceBy(this.selectKeys, [el], 'tagId');
            }
        },
        async tagUpData(type) {
            if (!type) return that.$message.error(`选择标签修改类型`);
            const that = this;
            let params = {
                tagType: type
            };
            if (that.contactId.length === 0) return that.$message.error(`请选择客户`);
            if (type === 1) params.tagId = _.map(that.selectKeys, 'tagId');
            else if (type === 2) params.tagIdDel = _.map(that.selectKeys, 'tagId');
            console.log(type, that.selectKeys);
            if ((type === 1 && params.tagId.length === 0) || (type === 2 && params.tagIdDel.length === 0)) return that.$message.error(`请选择标签`);
            try {
                this.$confirm({
                    title: `确认批量${parseInt(type, 10) === 1 ? '新增' : '删除'}标签？`,
                    icon: 'info-circle',
                    async onOk() {
                        try {
                            if (that.contactId && that.contactId.length > 0) params.contactId = that.contactId;
                            const res = await api.postAddTag(params);
                            if (res.code !== 0) return that.$message.error(`批量操作报错`);
                            that.$message.success(`成功批量${parseInt(type, 10) === 1 ? '新增' : '删除'}客户标签。`);
                            that.closeChild();
                            that.updateData(type);
                            // that.close();
                        } catch (err) {
                            console.log(err);
                        }
                    },
                    onCancel() {}
                });
            } catch (err) {
                console.log(err);
            }
        },
        openTag() {
            this.visibleTag = true;
        },
        closeTag() {
            this.visibleTag = false;
            this.getTag();
        },
        // 更新列表数据
        updateData(type) {
            this.data.forEach(item => {
                this.selectKeys.forEach(el => {
                    if (parseInt(type, 10) === 2) item.tag = _.differenceBy(item.tag, [el], 'tagId');
                    else if (parseInt(type, 10) === 1 && _.indexOf(_.map(item.tag, 'tagId'), el.tagId) < 0) item.tag.push(el);
                })
                return item;
            });
            this.selectKeys = [];
        },
    },
}
</script>

<style>
#cus_drawer_1 .customer_list {
    height: calc(100vh - 30px);
}
#cus_drawer_1 .customer_in,
#cus_drawer_1 .step_1 {
    transition:all 0.3s cubic-bezier(.075,.82,.165,1) 0s;
	-moz-transition:all 0.3s cubic-bezier(.075,.82,.165,1) 0s;
	-webkit-transition:all 0.3s cubic-bezier(.075,.82,.165,1) 0s;
	-o-transition:all 0.3s cubic-bezier(.075,.82,.165,1) 0s;
}
#cus_drawer_1 .customer_in.customer_in_active,
#cus_drawer_1 .step_1.customer_in_active {
    width: calc(100% - 500px);
}
#cus_drawer_2 .tag_list {
    height: calc(100vh - 30px);
}
#cus_drawer_2 .tag_in {
    padding-bottom: 60px;
}
#cus_drawer_1.ant-drawer-open .ant-drawer-wrapper-body,
#cus_drawer_2.ant-drawer-open .ant-drawer-wrapper-body {
    padding-top: 55px;
}
#cus_drawer_1.ant-drawer-open .ant-drawer-header {
    position: fixed;
    width: 80%;
    top: 0;
    right: 0;
    z-index: 10;
}
#cus_drawer_2.ant-drawer-open .ant-drawer-header {
    position: fixed;
    width: 500px;
    top: 0;
    right: 0;
    z-index: 10;
}
</style>